import { DocumentMoveNodeService } from './document-move-node.service';
import { CompanyDocumentAssignmentsTable } from './tables/company-document-assignments/company-document-assignments.table';
import { AllDocumentNodesIndexTable } from './tables/document-nodes-index/all-document-nodes-index.table';
import { DocumentNodesIndexTable } from './tables/document-nodes-index/document-nodes-index.table';
import { EmployeeDocumentNodesIndexTable } from './tables/document-nodes-index/employee-document-nodes-index.table';
import { ManageTagsIndexTable } from './tables/manage-tags-index/manage-tags-index.table';
import { OfferLetterTemplateAssignmentsTable } from './tables/offer-letter-template-assignments/offer-letter-template-assignments.table';

const Services = [
    AllDocumentNodesIndexTable,
    DocumentNodesIndexTable,
    EmployeeDocumentNodesIndexTable,
    ManageTagsIndexTable,
    DocumentMoveNodeService,
];

export {
    AllDocumentNodesIndexTable,
    CompanyDocumentAssignmentsTable,
    DocumentMoveNodeService,
    DocumentNodesIndexTable,
    EmployeeDocumentNodesIndexTable,
    ManageTagsIndexTable,
    OfferLetterTemplateAssignmentsTable,
    Services,
};
